import styled, { css } from 'styled-components'

export const Sections = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['16']};

    && > * {
      flex: none;
      height: auto;
    }
  `,
)
